import { File, immerable } from '@topwrite/common';

File.prototype[immerable] = true;

declare module '@topwrite/common' {

    export interface File {
        [immerable]: boolean;
    }

}
